// src/services/transactionApi.ts
import apiClient from "./apiClient";

export const fetchTransactions = (eventId: string) =>
  apiClient.get(`/transactions/events/${eventId}`);

export const createTransaction = (eventId: string, payload: any) =>
  apiClient.post(`/transactions/events/${eventId}`, payload);

export const refundTransaction = (transactionId: string, payload: any) =>
  apiClient.post(`/transactions/${transactionId}/refund`, payload);
